import { SectionCard } from './SectionCard';

interface PointsInfoProps {
  points: number;
  /** 點數等值金額（元），顯示請用 formatMoney */
  pointsYuanEquivalent: number;
}

export function PointsInfo({ points, pointsYuanEquivalent }: PointsInfoProps) {
  return (
    <SectionCard title="點數資訊">
      <div className="space-y-1">
        <div className="text-sm text-gray-600 mb-1">當前點數</div>
        <div className="text-3xl font-bold text-blue-600">
          {points.toLocaleString()}
        </div>
        <div className="text-xs text-gray-500 mt-1">（20 點 = 1 元）</div>
      </div>
    </SectionCard>
  );
}
